<script setup>
import {listServiceProject} from "@/api/business/serviceProject";
import {listBase as storeListBase} from "@/api/store/base";
import {addDiscountsStrategy, updateDiscountsStrategy} from "@/api/business/discountsStrategy";

const props = defineProps({
  title: {
    type: String,
    default: ""
  },
  openType: {
    type: Number,
    default: 0  //0:新增，1：查看，2，修改
  },
  modelValue: {
    type: Boolean,
    default: false
  },
  form: {
    type: Object,
    default: {}
  },
  rules: {
    type: Object,
    default: {}
  }
});

const week = ref([
  {label: '2', value: '星期一'},
  {label: '3', value: '星期二'},
  {label: '4', value: '星期三'},
  {label: '5', value: '星期四'},
  {label: '6', value: '星期五'},
  {label: '7', value: '星期六'},
  {label: '1', value: '星期日'}
])
const selectedWeek = ref([])
const timeRangeList = ref([{range: []}])

function addTimeRange() {
  timeRangeList.value.push({range: []})
}

function removeTimeRange(index) {
  timeRangeList.value.splice(index, 1)
}

// 处理回显数据 - 分别监听特定字段，避免修改其他字段时触发重置
watch(() => props.form.unavailableWeeklyTimes, (newValue) => {
  if (newValue) {
    selectedWeek.value = newValue.split(',')
  } else {
    selectedWeek.value = []
  }
}, {immediate: true})

watch(() => props.form.unavailableTimeRanges, (newValue) => {
  // 只有在有数据且是修改模式时才进行数据回显
  if (newValue && props.form.id) {
    try {
      const timeRanges = JSON.parse(newValue)
      if (timeRanges && timeRanges.length > 0) {
        timeRangeList.value = timeRanges.map(item => ({
          range: [item.beginTime?.substring(0, 10), item.endTime?.substring(0, 10)]
        }))
      } else {
        timeRangeList.value = [{range: []}]
      }
    } catch (e) {
      console.error('解析 unavailableTimeRanges 失败:', e)
      timeRangeList.value = [{range: []}]
    }
  } else if (!props.form.id) {
    // 新增模式，保持默认值
    if (timeRangeList.value.length === 0) {
      timeRangeList.value = [{range: []}]
    }
  }
}, {immediate: true})

const title = computed(() => {
    return props.title;
  }
);
const form = computed(() => {
    console.log(props.form);
    return props.form;
  }
);
const rules = computed(() => {
    return props.rules;
  }
);
const {proxy} = getCurrentInstance();
const serviceProjectList = ref([]);
const storeOptions = ref([]);
const buttonLoading = ref(false);
const emit = defineEmits(["refresh", "refList", "update:modelValue"]);

function getServiceProjectList() {
  listServiceProject({status: 1}).then(res => {
    serviceProjectList.value = res.rows;
    serviceProjectList.value.unshift({id: "0", serviceName: "不限服务项目"});
  });
}

function getStore() {
  storeListBase().then((response) => {
    storeOptions.value = response.rows;
    storeOptions.value.unshift({storeId: "0", storeName: "不限门店"});
  });
}

function changeModelValue(value) {
  emit("update:modelValue", value)
}

/** 提交按钮 */
function submitForm(number) {
  proxy.$refs["discountsStrategyRef"].validate(valid => {
    if (valid) {
      buttonLoading.value = true;

      // 将适用门店存入一个临时变量，请求结束后再将临时变量赋值给原来的使用门店。避免.map方法报错，不会发送请求
      form.value.temUseStore = form.value.useStore

      if (form.value.useStore) {
        form.value.useStoreDesc = form.value.useStore.map((item) => {
          return storeOptions.value.filter((obj) => obj.storeId === item)[0].storeName;
        });
        form.value.useStore = form.value.useStore.toString();
        form.value.useStoreDesc = form.value.useStoreDesc.toString();
      }
      form.value.useServiceId = form.value.useService.join(",");
      let a = form.value.useService.map((item) => {
        return serviceProjectList.value.filter((obj) => obj.id === item)[0].serviceName;
      });
      form.value.useServiceDesc = a.join(",");
      if (form.value.validType == 0) {
        form.value.startTime = form.value.dateRange[0];
        form.value.endTime = form.value.dateRange[1];
      }


      form.value.unavailableWeeklyTimes = selectedWeek.value.join(",");

      const timeRanges = timeRangeList.value.map(item => {
        const beginDate = item.range?.[0]
        const endDate = item.range?.[1]
        if (!beginDate || !endDate) return null
        return {
          beginTime: beginDate + ' 00:00:00',
          endTime: endDate + ' 23:59:59'
        }
      }).filter(Boolean)

      form.value.unavailableTimeRanges = JSON.stringify(timeRanges);

      if (form.value.id != null) {
        updateDiscountsStrategy(form.value).then(response => {
          selectedWeek.value = []
          timeRangeList.value = []
          proxy.$modal.msgSuccess("修改成功");
          cancel();
        }).finally(() => {
          // 将临时变量赋值给原来的使用门店。避免.map方法报错，不会发送请求
          form.value.useStore = form.value.temUseStore
          buttonLoading.value = false;
        });
      } else {
        addDiscountsStrategy(form.value).then(response => {
          selectedWeek.value = []
          timeRangeList.value = []
          proxy.$modal.msgSuccess("新增成功");
          cancel();
        }).finally(() => {
          // 将临时变量赋值给原来的使用门店。避免.map方法报错，不会发送请求
          form.value.useStore = form.value.temUseStore
          buttonLoading.value = false;
        });
      }
    }
  });
}

function cancel() {
  changeModelValue(false)
  emit("refresh");
  emit("refList");
}

getServiceProjectList();
getStore();
</script>

<template>
  <!-- 添加或修改优惠策略对话框 -->
  <el-dialog :title="title" :modelValue="modelValue" @update:model-value="changeModelValue" width="880px"
             append-to-body>
    <el-form ref="discountsStrategyRef" :model="form" :rules="rules" label-width="150px">
      <el-form-item label="优惠券名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入优惠券名称" style="width: 50%"/>
      </el-form-item>
      <el-form-item label="优惠券类型" prop="discountsType">
        <el-radio-group v-model="form.discountsType">
          <el-radio label="1">满减券</el-radio>
          <el-radio label="2">折扣券</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="减免金额" prop="discountsPrice" v-if="form.discountsType == 1">
        <el-input-number controls-position="right" v-model="form.discountsPrice" :precision="2" :step="1" :min="0.01"
                         placeholder="请输入减免金额" style="width: 50%"/>
      </el-form-item>
      <el-form-item label="折扣" prop="discount" v-if="form.discountsType == 2">
        <div style="width: 100%">
          <el-input-number controls-position="right" v-model="form.discount" :precision="1" :step="1" :min="0.1"
                           :max="10"
                           placeholder="请输入折扣" style="width: 50%"/>
          <div class="tip">
            折扣范围0.1-10，9.5表示95折
          </div>
        </div>
      </el-form-item>
      <el-form-item label="最低消费金额" prop="reachPrice">
        <el-input-number controls-position="right" v-model="form.reachPrice" :precision="2" :step="1" :min="0.00"
                         placeholder="请输入最低消费金额" style="width: 50%"/>
      </el-form-item>
      <el-form-item label="到期类型" prop="validType">
        <el-radio-group v-model="form.validType">
          <el-radio :label="1">领取后生效</el-radio>
          <el-radio :label="0">固定时间</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="有效天数" prop="effectiveDays" v-if="form.validType == 1">
        <el-input v-model="form.effectiveDays" placeholder="请输入有效天数" style="width: 50%"/>
      </el-form-item>
      <el-form-item label="有效时间" prop="dateRange" v-if="form.validType == 0">
        <div style="display: flex; gap: 10px; align-items: center;">
          <el-date-picker clearable
                          v-model="form.dateRange"
                          type="datetimerange"
                          value-format="YYYY-MM-DD HH:mm:ss"
                          :default-time="[new Date(2000, 1, 1, 0, 0, 0), new Date(2000, 1, 1, 23, 59, 59)]"
                          start-placeholder="开始日期时间"
                          end-placeholder="结束日期时间">
          </el-date-picker>
        </div>
      </el-form-item>
      <el-form-item label="适用服务项目" prop="useService">
        <el-select
          multiple
          clearable
          v-model="form.useService" filterable placeholder="请选择适用服务项目" style="width: 50%">
          <el-option v-for="(item,index) in serviceProjectList"
                     :key="index"
                     :value="item.id"
                     :label="item.serviceName">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="可用门店" prop="useStore">
        <el-select
          v-model="form.useStore"
          placeholder="请选择可用门店"
          clearable
          multiple
          style="width: 50%">
          <el-option
            v-for="dict in storeOptions"
            :key="dict.storeId"
            :label="dict.storeName"
            :value="dict.storeId"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否限制使用次数" prop="isLimit">
        <el-radio-group v-model="form.isLimit" @change="()=>{form.degree = null}">
          <el-radio :label='1'>是</el-radio>
          <el-radio :label='0'>否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="form.isLimit === 1" label="可用次数" prop="degree">
        <el-input-number controls-position="right" v-model="form.degree" :step="1" :min="1"
                         placeholder="请输入可用次数" style="width: 50%"/>
      </el-form-item>
      <el-form-item label="是否仅首次消费使用" prop="isFirst">
        <div>
          <el-radio-group v-model="form.isFirst">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
          <div class="tip">
            仅首次消费使用是指用户第一次下单时，才能使用该优惠券，对于之前已经有订单的用户，之后领取的此类优惠券则不可用
          </div>
        </div>
      </el-form-item>
      <el-form-item label="是否显示在领券中心" prop="isVisible">
        <div>
          <el-radio-group v-model="form.isVisible">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
          <div class="tip">领券中心是指娇娇儿小程序首页上的领券中心</div>
        </div>
      </el-form-item>
      <el-form-item label="状态" v-if="openType == 1" prop="state">
        <el-radio-group v-model="form.state">
          <el-radio :label="1">启用</el-radio>
          <el-radio :label="0">停用</el-radio>
        </el-radio-group>
      </el-form-item>


      <el-form-item label="每周不能使用时间" prop="unavailableWeeklyTimes">
        <el-checkbox-group v-model="selectedWeek">
          <el-checkbox v-for="item in week" :key="item.label" :label="item.label">
            {{ item.value }}
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item label="领取后几天生效" prop="delayEffectiveDays">
        <el-input-number v-model="form.delayEffectiveDays" placeholder="0表示立即生效" style="width: 50%"/>
      </el-form-item>

      <el-form-item label="不能使用的时间段" prop="unavailableTimeRanges">
        <div v-for="(item, index) in timeRangeList" :key="index"
             style="display: flex; gap: 10px; align-items: center; margin-bottom: 10px;">
          <el-date-picker clearable
                          v-model="item.range"
                          type="daterange"
                          value-format="YYYY-MM-DD"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          style="flex: 1">
          </el-date-picker>
          <el-button v-if="timeRangeList.length > 1" type="danger" size="small" @click="removeTimeRange(index)">删除
          </el-button>
          <el-button v-if="index === timeRangeList.length - 1" type="primary" size="small" @click="addTimeRange">新增
          </el-button>
        </div>
      </el-form-item>


      <el-form-item label="使用说明">
        <el-input type="textarea" v-model="form.remark" :rows="6" show-word-limit :maxlength="1000"></el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <el-button :loading="buttonLoading" v-if="openType != 1" type="primary" @click="submitForm()">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<style scoped>

</style>
